export type OrderIntakeSite = {
  siteId: string
  customerId: string
  customerNumber: string
  siteName: string
  country: string
  street: string
  postalCode: string
  city: string
  siteNumber: string
  orgUnitId: string
  dispatchPhoneNumbers?: string[]
  salesOffice?: string
  marketArea?: string
}

// Utility function for search string checking (from mobile app)
export const isSearchQueryIncludedInString = (str: string, searchQuery: string): boolean => {
  return str.toLowerCase().includes(searchQuery.toLowerCase())
}
